import { Circle, SquareProps, StyleProps } from "@chakra-ui/react";

interface PlusNTagProps<Item> extends StyleProps, SquareProps {
  maxCount: number;
  items: Item[];
}

export function PlusNTag<Item>({ items, maxCount = 1, ...rest }: PlusNTagProps<Item>) {
  if (items.length <= maxCount) {
    return null;
  }
  return (
    <Circle
      size="24px"
      bg="gray.100"
      color="gray.500"
      fontSize="xs"
      {...rest}
    >
      +
      {items.length - maxCount}
    </Circle>
  );
}

